import { ClientStatus } from '@cognitivecredit/ui-utils'

export interface User {
  Session: null | object
  attributes: {
    sub: string
    email_verified: boolean
    'custom:migrated': string
    'custom:clientId': string
    name: string
    phone_number_verified: boolean
    phone_number: string
    given_name: string
    family_name: string
    email: string
    'custom:userId': string
  }
  authenticationFlowType: string
  client: {
    displayName: string
    endpoint: string
    hasInstruments: boolean
    loanTradingDesk: boolean
    chatApp: boolean
    status: ClientStatus
    trialDates: {
      trialDaysRemaining: null | number
      trialEndDate: null | number
      trialStartDate: null | number
    }
  }
  keyPrefix: string
  signInUserSession: {
    idToken: {
      jwtToken: string
      payload: {
        aud: string
        auth_time: number
        'cognito:groups': string[]
        'cognito:username': string
        'custom:clientId': string
        'custom:migrated': string
        'custom:userId': string
        email: string
        email_verified: boolean
        event_id: string
        exp: number
        family_name: string
        given_name: string
        iat: number
        iss: string
        jti: string
        name: string
        origin_jti: string
        phone_number: string
        phone_number_verified: boolean
        sub: string
        token_use: string
      }
    }
    refreshToken: {
      token: string
    }
    accessToken: {
      jwtToken: string
      payload: {
        auth_time: number
        client_id: string
        'cognito:groups': string[]
        event_id: string
        exp: number
        iat: number
        iss: string
        jti: string
        origin_jti: string
        scope: string
        sub: string
        token_use: string
        username: string
      }
    }
    clockDrift: number
  }
  username: string
  isFirstSignIn: boolean
}
export interface License {
  availableToMe: boolean
  description: string
  id: string
  name: string
}
export interface WatchlistNotificationSetting {
  name: string
  id: string
  realtime: boolean
  daily: boolean
  weekly: boolean
}
export interface MarketMoverEmailPeriodSetting {
  allCompanies: boolean
  watchlistIds: string[]
}
export interface MarketMoverEmailNotifications {
  daily: MarketMoverEmailPeriodSetting
  weekly: MarketMoverEmailPeriodSetting
  monthly: MarketMoverEmailPeriodSetting
}

export interface InAppNotificationPreferences {
  chatApp: {
    popup: {
      answerGenerated: boolean
      promptShared: boolean
    }
    panel: {
      answerGenerated: boolean
      promptShared: boolean
    }
  }
  modelUpdate: {
    popup: {
      allCompanies: boolean
      watchlistIds: string[]
    }
    panel: {
      allCompanies: boolean
      watchlistIds: string[]
    }
  }
}

export interface UserPreferences {
  id: string
  messagePreferences: {
    showFinancialHelp: boolean
    showRACUploadHelp: boolean
    showUpdateHelp: boolean
    showWatchlistHelp: boolean
    showChatAppHelp: boolean
  }
  notifications: {
    dailyAll: boolean
    newCoverage: boolean
    realtimeAll: boolean
    weeklyAll: boolean
    watchlists: WatchlistNotificationSetting[]
  }
  sheetZoom: number
  timezone: string
  issueType: string
  selectedUniverses: string[]
}
export interface UserState {
  user: User
  preferences: UserPreferences
  licenseList: License[] | null
  selectedUniverses: License[] | null
  provisionalPreferences: Partial<UserPreferences>
  marketMoverEmailNotifications: MarketMoverEmailNotifications | null
  marketMoverEmailNotificationsDirty: boolean
  inAppNotificationPreferences: InAppNotificationPreferences | null
  isInAppNotificationPreferencesDirty: boolean
}

export default {
  user: undefined,
  preferences: {},
  licenseList: null,
  selectedUniverses: null,
  provisionalPreferences: {},
  marketMoverEmailNotifications: null,
  marketMoverEmailNotificationsDirty: false,
  inAppNotificationPreferences: null,
  isInAppNotificationPreferencesDirty: false,
}
